<template>
  <main-layout>
    <base-breadcrumb :routes="routes" />
    <base-widget class="pb-5 main-widget">
      <!-- heading -->
      <out-reach-heading
        :item="appointment"
        :loading="loading"
        class="no-border"
      />
      <events-summary
        v-if="!isRecommendation"
        :events="events"
        :loading="loading"
        :outreach-id="-1"
        @click="onActivityClicked"
      />
      <div
        v-if="isLivestream"
        class="row mb-4"
      >
        <div class="col-6">
          <livestream-chat-summary
            :history="chatHistory"
            :loading="chatLoading"
          />
        </div>
        <div class="col-6">
          <livestream-post-video />
        </div>
      </div>
      <div
        v-if="!isRecommendation && appointment.products_clicked && appointment.products_clicked.length"
        class="position-relative mb-4"
      >
        <products-clicked
          :items="appointment.products_clicked"
        >
          <template #actions>
            <base-button
              small
              class="m-0 py-2"
              @click="onDownloadViews"
            >
              <base-icon
                icon="download"
                class="mr-2"
              />
              Download Product Views
            </base-button>
          </template>
        </products-clicked>
      </div>
      <appointment-invitation-preview v-if="!isRecommendation" />
      <appointment-product-items />
    </base-widget>
  </main-layout>
</template>

<script>

import integrable from '@/components/mixins/integrable';
import OutReachHeading from '@/components/Widgets/OutReachs/OutReachHeading';
import ProductsClicked from '@/components/Widgets/OutReachs/ProductsClicked';
import { APPOINTMENT_EVENTS, APPOINTMENT_TYPES } from '@/_utilities/Enums';
import { objectToCsv, downloadStringAsFile } from '@/_utilities/generalUseUtils';

export default {

  name: 'AppointmentStats',
  components: {
    OutReachHeading,
    ProductsClicked,
  },
  mixins: [integrable],
  computed: {
    appointmentId() {
      return this.$route.params.appointmentId;
    },
    appointment() {
      return this.$store.state.appointments.item;
    },
    loading() {
      return this.$store.state.appointments.isLoading;
    },
    routes() {
      return [this.isIntegrated ? {
        name: 'Reports',
        link: '/reports',
      } : {
        name: 'Dashboard',
        link: '/dashboard',
      }, {
        name: this.$store.state.appointments.item.subject
          ? this.$store.state.appointments.item.subject : '',
      },
      ];
    },
    events() {
      return [{
        name: APPOINTMENT_EVENTS.invited,
        value: this.appointment.recipient_count,
      }, {
        name: APPOINTMENT_EVENTS.attended,
        value: this.appointment.attended,
      }, {
        name: APPOINTMENT_EVENTS.like,
        value: this.appointment.likes,
      }, {
        name: APPOINTMENT_EVENTS.click,
        value: this.appointment.clicks,
      }];
    },
    isLivestream() {
      return this.appointment.appointment_type === APPOINTMENT_TYPES.LIVESTREAM;
    },
    isRecommendation() {
      return this.appointment.appointment_type === APPOINTMENT_TYPES.RECOMMENDATION;
    },
    chatHistory() {
      const { chat } = this.$store.state.appointments;
      if (!chat || this.chatLoading) return [];
      return chat.map((c) => ({
        author: c.author,
        date: this.$moment(c.date_modified) || this.$moment(c.date_created),
        body: c.body,
      })).sort((c1, c2) => c2.date - c1.date);
    },
    chatLoading() {
      return this.$store.state.appointments.chatLoading;
    },
  },
  mounted() {
    this.$store.dispatch('appointments/reset');
    this.fetchAppointmentData();
  },
  methods: {
    fetchAppointmentData() {
      this.$store.dispatch('appointments/getReportItem', this.appointmentId).then(() => {
        if (this.isLivestream) { this.$store.dispatch('appointments/getChat', this.appointmentId); }
      });
    },
    onActivityClicked(eventIndex) {
      const event = this.events[eventIndex];
      const appointmentEvent = Object.entries(APPOINTMENT_EVENTS).find(([key, val]) => val === event.name)[0];
      const { customerId } = this.$route.params;
      const url = `${customerId ? `/clients/${customerId}` : '/reports'}/appointment/${
        this.appointmentId}/activity/${appointmentEvent}`;
      this.$router.push(url);
    },
    onDownloadViews() {
      let views = this.appointment.products_clicked;
      if (!views || views.length === 0) return;
      // Clean data a bit
      views = views.map((v) => {
        const {
        // eslint-disable-next-line
          url, title, price, site_url, external_url, thumb, size_info, external_id, view_count,
        } = v;
        return {
          brand: v.brand?.name ?? '',
          url,
          title,
          price,
          site_url,
          external_url,
          thumb,
          size_info,
          external_id,
          view_count,
        };
      });
      const csv = objectToCsv(views);

      const filename = `${this.$options.filters.striphtml(
        this.appointment.subject,
      )}-views.csv`;
      downloadStringAsFile(csv, filename).then(() => {
        console.log('Download generated.');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-widget {
  // Main container paddings
  padding: 0;

  ::v-deep>.sl-card>.card-body {
    padding: 1.5rem 2.25rem;
  }

  .base-widget__content {
    >.sl-card {
      // vertical separation between sections
      padding-bottom: 25px;
    }

    :not(.no-border) {
      ::v-deep & .card-body {
        // Gray round card borders
        border: solid 1px #33333344;
      }
    }

    ::v-deep & .card-body {
      border-radius: 5px;
      overflow: hidden;
    }
  }
}
::v-deep .card-body {
  padding: 1.875rem;
}
</style>
